export default __webpack_public_path__ + "static/media/Group1277.c8abe1cc.svg";